/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VmcOrgStateEnum = 'ONBOARDED' | 'READY' | 'ASSIGNED' | 'UNLINKING';

export const VmcOrgStateEnum = {

    ONBOARDED: 'ONBOARDED' as VmcOrgStateEnum,

    READY: 'READY' as VmcOrgStateEnum,

    ASSIGNED: 'ASSIGNED' as VmcOrgStateEnum,

    UNLINKING: 'UNLINKING' as VmcOrgStateEnum
};

